export default __webpack_public_path__ + "static/media/Commerce.e1e38f4f.png";